import React, {Component} from 'react';

class Itemlist extends Component {
  render(){
      return(
        <ul className="list-result-01">
            {(() => {
              if(this.props.itemsLength > 1){
                return (
                  this.props.items.map((item, index) => {
                    return (
                      <li key={index}>
                          <a href={item.url}>
                            <b className="title" dangerouslySetInnerHTML={{__html: item.title}}></b>
                            <span className="img" > <img src={item.img_url+'&type=medium'} alt="" /></span>
                            <span className="text" dangerouslySetInnerHTML={{__html: item.body}}></span>
                            <span className="url">{item.url}</span>
                            </a>
                      </li>
                    )
                  })
                )
              }else if(this.props.itemsLength === 1){
                return (
                  <li key="1">
                      <a href={this.props.items.url}>
                        <b className="title" dangerouslySetInnerHTML={{__html: this.props.items.title}}></b>
                        <span className="img" > <img src={this.props.items.img_url+'&type=medium'} alt="" /></span>
                        <span className="text" dangerouslySetInnerHTML={{__html: this.props.items.body}}></span>
                        <span className="url">{this.props.items.url}</span>
                        </a>
                  </li>
                )
              }
            })()}
        </ul>
    )
  }
}

export default Itemlist